var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticStyle:{"width":"52px !important"},attrs:{"src":require("@/assets/logo.png"),"alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }